<div class="d-flex flex-column">
  <form class="search-bar-container">
    <label for="odataSearchBar" [hidden]="!label || hideLabel">{{ label }}</label>
    <div [style.position]="'relative'">
      <input
        #searchBar
        (input)="searchChanged($event)"
        class="text-field search-text-field"
        [class.error]="hasErrors"
        [class.disabled]="disabled"
        id="odataSearchBar"
        name="odataSearchBar"
        [disabled]="disabled"
        placeholder="{{ placeHolder }}"
        [readOnly]="!!selectedItem"
        autocomplete="off"
        [type]="inputType" />
      <button
        *ngIf="displayValueInline && (!!selectedItem || searchBar.value.length > 0)"
        class="close"
        type="button"
        aria-label="Clear selection"
        i18n-aria-label
        (click)="clearSelectedItem()"></button>
    </div>
  </form>
  <div
    popper
    [popper]="popperContent"
    [popperShowOnStart]="false"
    [popperTrigger]="NgxPopperjsTriggers.none"
    [popperModifiers]="popperModifier"
    [popperHideOnClickOutside]="false"
    [popperHideOnScroll]="false"
    [popperPreventOverflow]="false"
    [popperTarget]="searchBar"
    [popperPositionFixed]="false"
    [popperApplyClass]="popperClass"
    [popperStyles]="popperStyles"
    [popperPlacement]="NgxPopperjsPlacements.BOTTOMSTART"></div>
  <popper-content #popperContent [style.z-index]="1500" clickOutside (onClickOutside)="handleClickOutside()">
    <div class="loading-container" [hidden]="!(isLoading$ | async)">
      <app-loading [hidden]="!(isLoading$ | async)" [options]="(loadingOptions$ | async) ?? undefined" />
    </div>
    <app-look-ahead-list
      [customItemTemplate]="customItemTemplate"
      [lookAheadItems]="lookAheadItems"
      [useProfileItems]="useProfileListItems"
      (lookAheadItemClicked)="itemSelected($event)" />
    <ng-container *ngIf="!lookAheadItems.length && !(isLoading$ | async)">
      <span class="no-results" i18n>No results found</span>
    </ng-container>
  </popper-content>
</div>
